export default "__VITE_IMAGE_ASSET__5b2986da__";